<style>
.vs-card--content {
    margin-bottom: 0;
}
.field-label {
    font-weight: 600;
    color: #444;
    font-size: 13px;
}
.field-value {
    font-size: 13px;
    color: #222;
}
.section-title {
    font-size: 15px;
    font-weight: 700;
    color: #333;
    margin-bottom: 12px;
    padding-bottom: 6px;
    border-bottom: 2px solid #e8e8e8;
}
.status-badge {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
}
.lampiran-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 10px;
    background: #f8f9fa;
    border-radius: 6px;
    margin-bottom: 6px;
    font-size: 13px;
}
.lampiran-icon {
    font-size: 18px;
    color: #6c757d;
}
.riwayat-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}
.riwayat-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin-top: 4px;
    flex-shrink: 0;
}
.approval-form-box {
    background: #f8f9fa;
    border: 1px solid #e0e0e0;
    border-radius: 10px;
    padding: 20px 24px;
    margin-top: 8px;
}
.nego-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 14px;
}
.nego-row.self {
    flex-direction: row-reverse;
}
.nego-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: white;
    flex-shrink: 0;
}
.nego-bubble {
    background: #f0f4ff;
    border: 1px solid #c7d2fe;
    border-radius: 0 10px 10px 10px;
    padding: 10px 14px;
    font-size: 13px;
    flex: 1;
}
.nego-bubble.self {
    background: #f0fdf4;
    border-color: #bbf7d0;
    border-radius: 10px 0 10px 10px;
}
.nego-form-box {
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 10px;
    padding: 16px 20px;
    margin-top: 12px;
}
.lampiran-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;
}
.lampiran-row .file-label {
    font-size: 12px;
    color: #28a745;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>

<template>
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card class="p-4 mb-6">

                <!-- ===== HEADER CARD ===== -->
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <div style="margin-left: 12px">
                            <h4 style="margin:0">Approval Surat Pesanan</h4>
                            <span style="font-size:12px;color:#888">{{ data.nomor_pesanan }}</span>
                        </div>
                    </div>
                    <span class="status-badge" :style="statusStyle(data.status)">
                        {{ statusLabel(data.status) }}
                    </span>
                </div>

                <!-- ===== SECTION 1: INFO PESANAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Informasi Pesanan</p>
                    <div class="vx-row">
                        <div class="w-full vx-col lg:w-1/2">
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Obyek</div>
                                <div class="w-2/3 vx-col field-value">{{ data.obyek }}</div>
                            </div>
                            <div class="hidden mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Ekspektasi Selesai</div>
                                <div class="w-2/3 vx-col field-value">{{ data.ekspektasi_selesai || '-' }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Selesai Paling Lambat</div>
                                <div class="w-2/3 vx-col field-value">{{ data.selesai_paling_lambat }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">No. Rekg</div>
                                <div class="w-2/3 vx-col field-value">045.01.19</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Pemakaian Anggaran</div>
                                <div class="w-2/3 vx-col field-value">RKAP 2026</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Total Anggaran</div>
                                <div class="w-2/3 vx-col field-value">Rp 1.000.000.000</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">No.PABI/PP</div>
                                <div class="w-2/3 vx-col field-value">2PPA/PBI/17/1/2025</div>
                            </div>                            
                        </div>
                        <div class="w-full vx-col lg:w-1/2">
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">PKS</div>
                                <div class="w-2/3 vx-col field-value">{{ data.pks }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Tanggal Pesan</div>
                                <div class="w-2/3 vx-col field-value">{{ data.tanggal_pesan }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Nama Regional Head</div>
                                <div class="w-2/3 vx-col field-value">{{ data.nama_regional_head }}</div>
                            </div>
                            <div class="mt-1 mb-3 vx-row">
                                <div class="w-1/3 vx-col field-label">Email Regional Head</div>
                                <div class="w-2/3 vx-col field-value">{{ data.email_regional_head }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===== SECTION 2: DETIL PESANAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Detil Pesanan</p>
                    <vs-table :data="data.details" hoverFlat>
                        <template slot="thead">
                            <vs-th style="width:40px">No</vs-th>
                            <vs-th style="min-width:200px">Nama Produk</vs-th>
                            <vs-th style="min-width:180px">Keterangan</vs-th>
                            <vs-th style="min-width:90px">Jumlah Pesan</vs-th>
                            <vs-th style="min-width:80px">Satuan</vs-th>
                            <vs-th style="min-width:140px">Harga PMT</vs-th>
                            <vs-th style="min-width:160px">Harga Pengajuan</vs-th>
                            <vs-th style="min-width:150px">Total Selisih Harga</vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr :key="i" v-for="(d, i) in data">
                                <vs-td>{{ i + 1 }}</vs-td>
                                <vs-td>{{ d.product_name }}</vs-td>
                                <vs-td>{{ d.keterangan }}</vs-td>
                                <vs-td>{{ d.jumlah }}</vs-td>
                                <vs-td>{{ d.satuan }}</vs-td>
                                <vs-td>{{ formatRupiah(d.harga_pmt) }}</vs-td>
                                <vs-td>{{ formatRupiah(d.harga_diinginkan) }}</vs-td>
                                <vs-td>{{ formatRupiah(d.total_selisih) }}</vs-td>
                            </vs-tr>
                            <vs-tr style="font-weight:700;background:#eef2ff;border-top:2px solid #c7d2fe">
                                <vs-td colspan="3" style="text-align:right;font-size:13px;color:#3730a3;padding-right:12px">TOTAL</vs-td>
                                <vs-td style="font-size:13px;color:#3730a3">{{ totalJumlah }}</vs-td>
                                <vs-td></vs-td>
                                <vs-td style="font-size:13px;color:#3730a3">{{ formatRupiah(totalHargaPmt) }}</vs-td>
                                <vs-td style="font-size:13px;color:#3730a3">{{ formatRupiah(totalHargaDiinginkan) }}</vs-td>
                                <vs-td style="font-size:13px;color:#3730a3">{{ formatRupiah(totalSelisih) }}</vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>

                <!-- ===== SECTION 3: LAMPIRAN DOKUMEN ===== -->
                <div class="mt-6">
                    <p class="section-title">Lampiran Dokumen Permohonan</p>
                    <div
                        v-for="(file, fi) in data.lampiran"
                        :key="fi"
                        class="lampiran-item"
                    >
                        <span class="material-icons lampiran-icon">attach_file</span>
                        <span style="width:100px;font-weight:600;color:#555">{{ file.jenis_label }}</span>
                        <span style="flex:1">{{ file.nama }}</span>
                        <span style="flex:1">2026-06-15 Andi L.M.</span>
                        <vs-button
                            size="small"
                            type="border"
                            icon="download"
                            @click="downloadLampiran(file)"
                        >Unduh</vs-button>
                    </div>
                    <p v-if="!data.lampiran || data.lampiran.length === 0" style="color:#aaa;font-size:13px">
                        Tidak ada lampiran
                    </p>

                    <p class="section-title">Lampiran Dokumen SP</p>
                    <div
                        v-for="(file, fi) in data.lampiran2"
                        :key="fi"
                        class="lampiran-row"
                    >
                        <vs-select
                            v-model="file.jenis"
                            width="160px"
                            class="selectExample"
                        >
                            <vs-select-item
                                v-for="(j, ji) in jenisFile"
                                :key="ji"
                                :value="j.value"
                                :text="j.label"
                            />
                        </vs-select>
                        <input
                            type="file"
                            @change="onFileChange($event, fi)"
                            style="flex: 1; padding: 4px 0; font-size: 13px;"
                        />
                        <span v-if="file.nama" class="file-label">{{ file.nama }}</span>
                        <vs-button
                            color="danger"
                            type="border"
                            icon="delete"
                            size="small"
                            @click="removeLampiran(fi)"
                        ></vs-button>
                    </div>
                    <vs-button type="border" class="mt-2" @click="addLampiran()">
                        + Tambah Lampiran
                    </vs-button>
                </div>

                <!-- ===== SECTION 4: CATATAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Catatan</p>
                    <div
                        style="background:#fffdf0;border:1px solid #e8e0b0;border-radius:6px;padding:12px 16px;font-size:13px;min-height:50px;white-space:pre-line"
                    >{{ data.catatan || '-' }}</div>
                </div>

                <!-- ===== SECTION 5: TEMBUSAN ===== -->
                <div class="mt-6">
                    <p class="section-title">Tembusan</p>
                    <div class="vx-row">
                        <div class="w-full vx-col lg:w-1/2">
                            <p style="font-size:12px;font-weight:600;color:#888;margin-bottom:6px">Jenis Tembusan</p>
                            <div
                                v-for="(t, ti) in data.tembusan2"
                                :key="'t2-'+ti"
                                style="display:inline-block;background:#e9ecef;border-radius:4px;padding:3px 10px;margin:0 4px 4px 0;font-size:12px"
                            >{{ t.label }}</div>
                        </div>
                        <div class="w-full vx-col lg:w-1/2">
                            <p style="font-size:12px;font-weight:600;color:#888;margin-bottom:6px">Dikirimkan Kepada</p>
                            <div
                                v-for="(u, ui) in data.tembusan"
                                :key="'tu-'+ui"
                                style="display:flex;align-items:center;gap:6px;margin-bottom:4px;font-size:13px"
                            >
                                <span class="material-icons" style="font-size:16px;color:#888">person</span>
                                {{ u.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===== SECTION 6: RIWAYAT APPROVAL ===== -->
                <div class="mt-6" v-if="data.approvals && data.approvals.length > 0">
                    <p class="section-title">Riwayat Approval</p>
                    <div
                        v-for="(a, ai) in data.approvals"
                        :key="'ap-'+ai"
                        class="riwayat-row"
                    >
                        <div
                            class="riwayat-dot"
                            :style="a.action === 'setuju' ? 'background:#28a745' : 'background:#dc3545'"
                        ></div>
                        <div style="flex:1">
                            <div style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">
                                <span style="font-weight:600;font-size:13px">{{ a.approver_name }}</span>
                                <span
                                    class="status-badge"
                                    :style="a.action === 'setuju'
                                        ? 'background:#D4EDDA;color:#155724;padding:1px 8px;font-size:11px'
                                        : 'background:#F8D7DA;color:#721C24;padding:1px 8px;font-size:11px'"
                                >{{ a.action === 'setuju' ? 'Disetujui' : 'Ditolak' }}</span>
                                <span style="font-size:11px;color:#aaa">{{ a.created_at }}</span>
                            </div>
                            <div v-if="a.keterangan" style="font-size:12px;color:#666;margin-top:2px">
                                "{{ a.keterangan }}"
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===== SECTION 6.5: NEGOSIASI ANTAR HEAD ===== -->
                <div class="mt-6">
                    <p class="section-title" style="border-bottom-color:#fbbf24">
                        <span style="display:inline-flex;align-items:center;gap:6px">
                            <span class="material-icons" style="font-size:16px;color:#f59e0b;vertical-align:middle">forum</span>
                            Diskusi
                        </span>
                    </p>

                    <div
                        v-if="!data.negosiasiList || data.negosiasiList.length === 0"
                        style="color:#aaa;font-size:13px;padding:6px 0"
                    >
                        Belum ada komentar negosiasi.
                    </div>

                    <div
                        v-for="(n, ni) in data.negosiasiList"
                        :key="'nego-'+ni"
                        class="nego-row"
                        :class="{ self: n.is_self }"
                    >
                        <div class="nego-avatar" :style="n.is_self ? 'background:#16a34a' : 'background:#2563eb'">
                            {{ n.nama.charAt(0) }}
                        </div>
                        <div class="nego-bubble" :class="{ self: n.is_self }">
                            <div style="display:flex;align-items:center;gap:8px;margin-bottom:5px;flex-wrap:wrap">
                                <span style="font-weight:700;font-size:12px">{{ n.nama }}</span>
                                <span style="font-size:11px;color:#888;background:#e5e7eb;border-radius:4px;padding:0 6px">{{ n.jabatan }}</span>
                                <span style="font-size:11px;color:#aaa;margin-left:auto">{{ n.created_at }}</span>
                            </div>
                            <div style="font-size:13px;color:#333;white-space:pre-line">{{ n.komentar }}</div>
                        </div>
                    </div>

                    <!-- Form kirim komentar -->
                    <div class="nego-form-box">
                        <label class="field-label" style="color:#92400e;display:block;margin-bottom:8px">
                            Tambahkan Komentar
                        </label>
                        <vs-textarea
                            v-model="formNego.komentar"
                            placeholder="Tulis komentar atau tanggapan negosiasi..."
                            height="80px"
                            class="w-full"
                        />
                        <div class="flex justify-end" style="margin-top:8px">
                            <vs-button
                                color="warning"
                                icon="send"
                                :disabled="isSubmittingNego || !formNego.komentar.trim()"
                                @click="submitNego"
                            >Kirim</vs-button>
                        </div>
                    </div>
                </div>

                <!-- ===== SECTION 7: FORM TINDAKAN APPROVAL ===== -->
                <div class="mt-8">
                    <p class="section-title">Tindakan Approval</p>
                    <div class="approval-form-box">
                        <div class="mb-4 vx-row">
                            <div class="w-full vx-col" style="margin-bottom:6px">
                                <label class="field-label">Keterangan / Catatan Approval</label>
                            </div>
                            <div class="w-full vx-col">
                                <vs-textarea
                                    v-model="form.keterangan"
                                    placeholder="Tambahkan catatan, alasan persetujuan, atau alasan penolakan..."
                                    height="100px"
                                    class="w-full"
                                />
                            </div>
                        </div>
                        <div class="flex items-center" style="gap:12px">
                            <vs-button
                                color="success"
                                icon="check_circle"
                                size="large"
                                :disabled="isSubmitting"
                                @click="submitApproval('setuju')"
                            >Setujui</vs-button>
                            <vs-button
                                color="danger"
                                icon="cancel"
                                size="large"
                                type="border"
                                :disabled="isSubmitting"
                                @click="confirmTolak"
                            >Tolak</vs-button>
                        </div>
                    </div>
                </div>

            </vs-card>
        </div>

        <!-- ===== DIALOG KONFIRMASI TOLAK ===== -->
        <vs-prompt
            @accept="submitApproval('tolak')"
            :active.sync="showConfirmTolak"
            title="Konfirmasi Penolakan"
            accept-text="Ya, Tolak"
            cancel-text="Batal"
            color="danger"
        >
            <div class="con-exemple-prompt">
                <p>Apakah Anda yakin ingin <b>menolak</b> surat pesanan ini?</p>
                <p v-if="form.keterangan" class="mt-2" style="font-size:12px;color:#555">
                    Keterangan: <i>{{ form.keterangan }}</i>
                </p>
                <vs-alert v-if="!form.keterangan" color="warning" class="mt-3">
                    Disarankan mengisi keterangan sebelum menolak.
                </vs-alert>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            isSubmitting: false,
            showConfirmTolak: false,
            data: {
                id: 1,
                nomor_pesanan: 'SP/SG/2025/001',
                pks: 'SEI GARO',
                obyek: 'PENGADAAN DAN PEMBUATAN BARU LORI REBUSAN 2,5 TON 10 (SEPULUH) UNIT',
                tanggal_pesan: '2025-09-20',
                ekspektasi_selesai: '2025-11-30',
                selesai_paling_lambat: '2025-12-07',
                nama_regional_head: 'Ahmad Gusmar Harahap',
                email_regional_head: 'ahmadgusmar.harahap@ptpn4.co.id',
                status: 'menunggu_pks',
                catatan: 'Pengadaan ini merupakan penggantian lori rebusan yang sudah tidak layak pakai. Kondisi lori lama sudah berkarat dan beberapa unit mengalami kerusakan pada as roda. Diharapkan pengadaan dapat diselesaikan sebelum musim panen raya.',
                details: [
                    {
                        line_id: 1,
                        product_name: 'Lori Rebusan 2,5 Ton',
                        keterangan: 'Penggantian unit lama yang rusak',
                        jumlah: 10,
                        satuan: 'UNIT',
                        harga_pmt: 185000000,
                        harga_diinginkan: 175000000,
                        total_selisih: 100000000,
                    },
                    {
                        line_id: 2,
                        product_name: 'As Roda Lori',
                        keterangan: 'Suku cadang tambahan',
                        jumlah: 20,
                        satuan: 'PCS',
                        harga_pmt: 4500000,
                        harga_diinginkan: 4000000,
                        total_selisih: 10000000,
                    },
                    {
                        line_id: 3,
                        product_name: 'Bantalan (Bearing) SKF',
                        keterangan: 'Ukuran 6310 2RS',
                        jumlah: 40,
                        satuan: 'PCS',
                        harga_pmt: 350000,
                        harga_diinginkan: 320000,
                        total_selisih: 1200000,
                    },
                ],
                lampiran2: [],
                lampiran: [
                    { jenis: 'gambar', jenis_label: 'Anggaran', nama: 'Justifikasi_Teknis_Pengadaan.docx' },
                    { jenis: 'dokumen', jenis_label: 'Lainnya', nama: 'dokumen_pendukung2.jpg' },
                ],
                tembusan2: [
                    { value: 'gambar', label: '2AKN' },
                    { value: 'dokumen', label: '3KGO' },
                    { value: 'dokumen2', label: 'Pertinggal' },
                ],
                tembusan: [
                    { id: 1, name: 'email1@ptpn4.co.id' },
                    { id: 2, name: 'email2@ptpn4.co.id' },
                    { id: 3, name: 'email3@ptpn4.co.id' },
                ],
                approvals: [
                    {
                        approver_name: 'Eko Prasetyo, ST (Regional Head)',
                        action: 'setuju',
                        keterangan: 'Sesuai kebutuhan lapangan dan sudah diverifikasi kondisi fisik lori.',
                        created_at: '2025-09-21 09:30',
                    },
                ],
                negosiasiList: [
                    {
                        id: 1,
                        nama: 'Ahmad Gusmar Harahap',
                        jabatan: 'Regional Head PKS',
                        komentar: 'Harga yang diinginkan untuk Lori Rebusan terlalu jauh dari harga PMT. Apakah ada justifikasi teknis yang lebih detail mengenai selisih harga Rp 10 juta per unit?',
                        created_at: '2025-09-21 10:00',
                        is_self: false,
                    },
                    {
                        id: 2,
                        nama: 'Budi Santoso',
                        jabatan: 'Regional Head 2',
                        komentar: 'Harga tersebut sudah berdasarkan survei pasar terbaru yang kami riset. Dokumen survei sudah dilampirkan di bagian lampiran. Kondisi unit lama sudah sangat kritis dan mengganggu produksi.',
                        created_at: '2025-09-21 11:30',
                        is_self: true,
                    },
                    {
                        id: 3,
                        nama: 'Ahmad Gusmar Harahap',
                        jabatan: 'Regional Head PKS',
                        komentar: 'Sudah saya cek dokumen surveinya. Apakah bisa direvisi menjadi Rp 178.000.000/unit sebagai titik tengah? Saya akan proses approval jika harga bisa disesuaikan.',
                        created_at: '2025-09-22 08:45',
                        is_self: false,
                    },
                    {
                        id: 4,
                        nama: 'Budi Santoso',
                        jabatan: 'Regional Head 2',
                        komentar: 'Baik, saya akan diskusikan dengan tim teknis terlebih dahulu. Mohon ditunggu 1-2 hari kerja.',
                        created_at: '2025-09-22 09:15',
                        is_self: true,
                    },
                ],
            },
            form: {
                keterangan: '',
            },
            formNego: {
                komentar: '',
            },
            isSubmittingNego: false,
            statusMap: {
                'menunggu_pks': { label: 'Menunggu Persetujuan Regional Head PKS', bg: '#FFF3CD', color: '#856404' },
                'menunggu_rh2': { label: 'Menunggu Persetujuan Regional Head 2',   bg: '#CCE5FF', color: '#004085' },
                'persiapan':    { label: 'Persiapan Produksi',                      bg: '#D4EDDA', color: '#155724' },
                'proses':       { label: 'Proses Produksi',                         bg: '#D1ECF1', color: '#0C5460' },
                'bast':         { label: 'BAST',                                    bg: '#E2D9F3', color: '#4A235A' },
            },
        }
    },
    computed: {
        totalJumlah() {
            if (!this.data.details) return 0
            return this.data.details.reduce((s, d) => s + (Number(d.jumlah) || 0), 0)
        },
        totalHargaPmt() {
            if (!this.data.details) return 0
            return this.data.details.reduce((s, d) => s + (Number(d.jumlah) * Number(d.harga_pmt) || 0), 0)
        },
        totalHargaDiinginkan() {
            if (!this.data.details) return 0
            return this.data.details.reduce((s, d) => s + (Number(d.jumlah) * Number(d.harga_diinginkan) || 0), 0)
        },
        totalSelisih() {
            if (!this.data.details) return 0
            return this.data.details.reduce((s, d) => s + (Number(d.total_selisih) || 0), 0)
        },
    },
    watch: {
        isLoading(val) {
            if (val) this.$vs.loading()
            else this.$vs.loading.close()
        },
    },
    methods: {
        back() {
            this.$router.push({ name: 'surat-pesanan' })
        },
        statusLabel(value) {
            return this.statusMap[value] ? this.statusMap[value].label : (value || '-')
        },
        statusStyle(value) {
            const s = this.statusMap[value]
            if (!s) return ''
            return `background:${s.bg};color:${s.color}`
        },
        formatRupiah(value) {
            if (!value && value !== 0) return '-'
            return 'Rp ' + Number(value).toLocaleString('id-ID')
        },
        downloadLampiran(file) {
            this.$vs.notify({
                color: 'primary',
                title: 'Unduh File',
                iconPack: 'feather',
                icon: 'icon-download',
                text: file.nama,
            })
        },
        addLampiran() {
            this.data.lampiran2.push({ jenis: 'dokumen', file: null, nama: '' })
        },
        removeLampiran(index) {
            this.data.lampiran2.splice(index, 1)
        },
        onFileChange(event, index) {
            const file = event.target.files[0]
            if (file) {
                this.data.lampiran2[index].file = file
                this.data.lampiran2[index].nama = file.name
            }
        },
        confirmTolak() {
            this.showConfirmTolak = true
        },
        submitNego() {
            if (!this.formNego.komentar.trim()) {
                this.$vs.notify({
                    color: 'warning',
                    title: 'Komentar Kosong',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    text: 'Tulis komentar sebelum mengirim',
                })
                return
            }
            this.isSubmittingNego = true
            // ganti dengan API call saat backend siap:
            // this.$http.post('surat-pesanan/' + this.data.id + '/negosiasi', { komentar: this.formNego.komentar })
            setTimeout(() => {
                this.data.negosiasiList.push({
                    id: Date.now(),
                    nama: 'Budi Santoso',
                    jabatan: 'Regional Head 2',
                    komentar: this.formNego.komentar,
                    created_at: new Date().toLocaleString('id-ID', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }),
                    is_self: true,
                })
                this.formNego.komentar = ''
                this.isSubmittingNego = false
                this.$vs.notify({
                    color: 'success',
                    title: 'Komentar Terkirim',
                    iconPack: 'feather',
                    icon: 'icon-check',
                    text: 'Komentar negosiasi berhasil dikirim',
                })
            }, 500)
        },
        submitApproval(action) {
            if (action === 'tolak' && !this.form.keterangan) {
                this.$vs.notify({
                    color: 'warning',
                    title: 'Keterangan Diperlukan',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    text: 'Isi keterangan sebelum menolak pesanan',
                })
                return
            }

            this.isSubmitting = true
            // ganti dengan API call saat backend siap:
            // this.$http.post('surat-pesanan/' + this.data.id + '/approval', { action, keterangan: this.form.keterangan })
            setTimeout(() => {
                this.isSubmitting = false
                this.$vs.notify({
                    color: action === 'setuju' ? 'success' : 'warning',
                    title: action === 'setuju' ? 'Berhasil Disetujui' : 'Pesanan Ditolak',
                    iconPack: 'feather',
                    icon: action === 'setuju' ? 'icon-check' : 'icon-x',
                    text: action === 'setuju'
                        ? 'Surat pesanan berhasil disetujui'
                        : 'Surat pesanan telah ditolak',
                })
                this.$router.push({ name: 'surat-pesanan' })
            }, 800)
        },
    },
    mounted() {
        // fetchData() — aktifkan saat backend siap
    },
}
</script>
